import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router";

import LinkView from './template/link.vue';
import FailView from './template/fail.vue';
import _404View from './template/404.vue';

Vue.use(VueRouter);

Vue.prototype.$site_name = window.location.hostname.split('.')[1];

const routes = [
    {
        path: "/link/failed",
        component: FailView
    },
    {
        path: "/link/:link",
        component: LinkView
    },
    {
        path: '/404',
        component: _404View
    },
    {
        path: '*',
        redirect: '/404'
    },
];

const router = new VueRouter({
    routes: routes,
    mode: 'history'
});


let vue = new Vue({
    el: '#app',
    render: handler => handler(App),
    router,
    data() {
        return {
            site_name: this.$site_name,
            host: window.location.host
        }
    }
});

window.__VUE__ = vue;